var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"save"},[_c('div',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.icons.save)}}),_c('p',{staticClass:"copy",domProps:{"innerHTML":_vm._s(_vm.copy)}})])}
var staticRenderFns = []

export { render, staticRenderFns }